import apiClient, { safeJson } from '@/api/client';
import { PatchSettlementTypeBody, PatchSettlementTypeResponse } from './types';

/**
 * @method patch
 * @brief 센터 정산 모드 변경 (base <-> tier)
 */
export const patchCenterSettlementType = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: PatchSettlementTypeBody;
}) => {
    const res = await apiClient.patch(`v1/centers/${centerId}/settlement-type`, {
        json: body,
    });

    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as PatchSettlementTypeResponse | null,
    };
};
